import React from "react";
import styles from "./style.module.css";
import Icon from "../ui/Icon/Icon";


const DEFAULT_TABS = [
  {
    title: "รายการปัจจุบันของฉัน",
    content: <div>Current Loans</div>,
  },
  {
    title: "ประวัติรายการ",
    content: <div>Loan History</div>,
  },
];

const Tabs = ({ tabs = DEFAULT_TABS, currentTab, tabSetter }) => {
  if (!currentTab) return null;
  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabHeader}>
        {tabs.map((tab, index) => (
          <button
            key={tab.title}
            className={`${styles.tabButton} ${
              currentTab.title === tab.title ? styles.active : styles.inActive
            }`}
            onClick={() => tabSetter(tab)}
          >
            {index === 0 && (
              <Icon
                name={
                  currentTab.title === tab.title ? "pink-document" : "document"
                }
              />
            )}
            {index === 1 && (
              <Icon
                name={currentTab.title === tab.title ? "pink-clock" : "clock"}
              />
            )}
            {tab.title}
          </button>
        ))}
      </div>
      {currentTab.content}
    </div>
  );
};

export default Tabs;
